import React from 'react';
import './App.css';
import './styles/lm-theme/css/notification.css';
import './styles/lm-theme/css/error-page.css';
import './styles/lm-theme/css/drop-downlist-custom.css';
import '@progress/kendo-svg-icons';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Logout from './pages/Logout';
import SSO from './pages/SSO';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import { useTranslation } from 'react-i18next';
import MainLayout from './components/MainLayout';
import LabelSearch from './pages/Configuration/Label/LabelSearch';
import ManageLabel from './pages/Configuration/Label/ManageLabel';
import AddLabelsToProject from './pages/Configuration/Label/AddLabelsToProject';
import EntitySearch from './pages/Configuration/Entity/EntitySearch';
import AddEntitiesToProject from './pages/Configuration/Entity/AddEntitiesToProject';
import UserSearch from './pages/Configuration/User/UserSearch';
import ManageEntity from './pages/Configuration/Entity/ManageEntity';
import AddUsersToProject from './pages/Configuration/User/AddUsersToProject';
import RoleSearch from './pages/Configuration/Roles/RoleSearch';
import AddRolesToProject from './pages/Configuration/Roles/AddRolesToProject';
import ManageRole from './pages/Configuration/User/ManageRole';
import ManageUsers from './pages/Configuration/Roles/ManageUsers';
import ManagePermissions from './pages/Configuration/Roles/ManagePermissions';
import { PermissionProvider } from './contexts/PermissionContext';
import Dashboard from './pages/DataLabeling/Dashboard';
import Search from './pages/DataLabeling/Search';
import Labeling from './pages/DataLabeling/Labeling';
import { ProjectProvider } from './contexts/ProjectContext';
import { LoadingProvider } from './contexts/LoadingContext';
import { ErrorBoundary } from "react-error-boundary";
import { ErrorPage } from './components/ErrorPage';
import ProjectDetails from './pages/Configuration/Project/ProjectDetails';
import DataflowProjectHistory from './pages/Configuration/Project/DataflowProjectHistory';
import ProjectNotificationEmails from 'pages/Configuration/Project/ProjectNotificationEmails';
import MissingPostsSearch from './pages/DataLabeling/Missings/MissingPostsSearch';
import DlpConfiguration from './pages/DlpConfiguration/DlpConfiguration';
import { DlpConfigToolRoute } from './components/DlpConfigToolRoute';

function App() {
  useTranslation();
  return (<>
    <NotificationProvider>
      <AuthProvider>
        <LoadingProvider>
          <PermissionProvider>
          <ProjectProvider>
            <Routes>
              <Route path="/login" element={<ErrorBoundary FallbackComponent={ErrorPage}><Login /></ErrorBoundary>} />
              <Route path="/logout" element={<ProtectedRoute><ErrorBoundary FallbackComponent={ErrorPage}><Logout /></ErrorBoundary></ProtectedRoute>} />        
              <Route path="/labels" element={<ProtectedRoute><MainLayout><LabelSearch /></MainLayout></ProtectedRoute>} />
              <Route path="/labels/addLabelsToProject" element={<ProtectedRoute><MainLayout><AddLabelsToProject/></MainLayout></ProtectedRoute>} />
              <Route path="/labels/manageLabel" element={<ProtectedRoute><MainLayout><ManageLabel/></MainLayout></ProtectedRoute>} />
              <Route path="/entities" element={<ProtectedRoute><MainLayout><EntitySearch /></MainLayout></ProtectedRoute>} />
              <Route path="/entities/addEntitiesToProject" element={<ProtectedRoute><MainLayout><AddEntitiesToProject/></MainLayout></ProtectedRoute>} />
              <Route path="/entities/manageEntity" element={<ProtectedRoute><MainLayout><ManageEntity/></MainLayout></ProtectedRoute>} />
              <Route path="/project" element={<ProtectedRoute><MainLayout><ProjectDetails/></MainLayout></ProtectedRoute>} />
              <Route path="/project/projectImportHistory" element={<ProtectedRoute><MainLayout><DataflowProjectHistory type={0} /></MainLayout></ProtectedRoute>} />
              <Route path="/project/projectExportHistory" element={<ProtectedRoute><MainLayout><DataflowProjectHistory type={1} /></MainLayout></ProtectedRoute>} />
              <Route path ="/project/ProjectNotificationEmails" element={<ProtectedRoute><MainLayout><ProjectNotificationEmails/></MainLayout></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute><MainLayout><UserSearch /></MainLayout></ProtectedRoute>} />
              <Route path="/users/addUsersToProject" element={<ProtectedRoute><MainLayout><AddUsersToProject/></MainLayout></ProtectedRoute>} />
              <Route path="/users/manageRoles" element={<ProtectedRoute><MainLayout><ManageRole/></MainLayout></ProtectedRoute>} />
              <Route path="/roles" element={<ProtectedRoute><MainLayout><RoleSearch/></MainLayout></ProtectedRoute>} />
              <Route path="/roles/addRolesToProject" element={<ProtectedRoute><MainLayout><AddRolesToProject/></MainLayout></ProtectedRoute>} />
              <Route path="/roles/manageUsers" element={<ProtectedRoute><MainLayout><ManageUsers/></MainLayout></ProtectedRoute>} />
              <Route path="/roles/managePermissions" element={<ProtectedRoute><MainLayout><ManagePermissions/></MainLayout></ProtectedRoute>} />
              <Route path="/missings" element={<ProtectedRoute><MainLayout><MissingPostsSearch/></MainLayout></ProtectedRoute>} />
              <Route path="/dlpConfiguration" element={<ProtectedRoute><MainLayout><ErrorBoundary FallbackComponent={ErrorPage}><DlpConfigToolRoute><DlpConfiguration /></DlpConfigToolRoute></ErrorBoundary></MainLayout></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><MainLayout><ErrorBoundary FallbackComponent={ErrorPage}><Dashboard /></ErrorBoundary></MainLayout></ProtectedRoute>} />
              <Route path="/search" element={<ProtectedRoute><MainLayout><ErrorBoundary FallbackComponent={ErrorPage}><Search /></ErrorBoundary></MainLayout></ProtectedRoute>} />
              <Route path="/dashboard/labeling" element={<ProtectedRoute><MainLayout><ErrorBoundary FallbackComponent={ErrorPage}><Labeling /></ErrorBoundary></MainLayout></ProtectedRoute>} />
              <Route path="/sso" element={<SSO />} />
              <Route path="/*" element={<Navigate to="/login" />} />
            </Routes>
            </ProjectProvider>
          </PermissionProvider>
        </LoadingProvider>
      </AuthProvider>
    </NotificationProvider>
  </>);
}
/// routes must be always wrapped in a Router component, so you have to wrap the App component in a Router component
const AppWrapper = () => {
  return (
    <Router basename={process.env.REACT_APP_DEPLOY_PATH}>
      <App />
    </Router>
  );
};

export default AppWrapper;
